import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { X } from "lucide-react";
import { Address } from "../../types/slice.types";

interface AddAddressCardProps {
  onSubmit: (address: Address) => void;
  onClose: () => void;
  initialAddress?: Address | null;
  mode?: "add" | "edit";
}

export const AddAddressCard = ({
  onSubmit,
  onClose,
  initialAddress = null,
  mode = "add",
}: AddAddressCardProps) => {
  const { t } = useTranslation();

  const [address, setAddress] = useState<Address>({
    building: "",
    street: "",
    city: "",
    country: "",
    phone: "",
  });

  useEffect(() => {
    if (initialAddress) {
      setAddress(initialAddress);
    }
  }, [initialAddress]);

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 backdrop-blur-sm">
      <div
        className="relative bg-popupLight dark:bg-popupDark shadow-lg rounded-2xl p-8 w-full max-w-md mx-4"
        onClick={(e) => e.stopPropagation()}
      >
        <button
          onClick={onClose}
          className="absolute top-3 right-3 text-gray-500 hover:text-gray-700 dark:hover:text-gray-300"
        >
          <X className="w-5 h-5" />
        </button>

        <h2 className="text-xl font-bold mb-6 text-center">
          {mode === "edit" ? t("Update Address") : t("Add Address")}
        </h2>

        <div className="space-y-4">
          {[
            ["building", "Building / House No"],
            ["street", "Street"],
            ["city", "City"],
            ["country", "Country"],
            ["phone", "Phone"],
          ].map(([key, label]) => (
            <div key={key}>
              <label className="block text-sm font-medium mb-1">
                {t(label)}
              </label>
              <input
                type="text"
                value={(address as any)[key]}
                onChange={(e) =>
                  setAddress((prev) => ({
                    ...prev,
                    [key]: e.target.value,
                  }))
                }
                className="w-full px-4 py-2 rounded-md dark:bg-gray-700"
              />
            </div>
          ))}

          <button
            onClick={() => onSubmit(address)}
            className="w-full bg-secondaryText dark:bg-secondaryTextDark text-primaryText py-2 rounded-md"
          >
            {mode === "edit" ? t("Update Address") : t("Save Address")}
          </button>
        </div>
      </div>
    </div>
  );
};
